// Splits a remaining-milliseconds value into zero-padded d/h/m/s. null once elapsed.
export function parts(ms) {
  if (!(ms > 0)) return null;
  const s = Math.floor(ms / 1000);
  const pad = (n) => String(n).padStart(2, '0');
  return {
    d: pad(Math.floor(s / 86400)),
    h: pad(Math.floor(s / 3600) % 24),
    m: pad(Math.floor(s / 60) % 60),
    s: pad(s % 60),
  };
}

// Compact form for the announcement bar: "5d 12h", or "12h 04m" inside the last day.
export function compact(p) {
  if (!p) return '';
  return Number(p.d) > 0 ? `${Number(p.d)}d ${p.h}h` : `${p.h}h ${p.m}m`;
}

function tick(el) {
  const p = parts(Date.parse(el.dataset.dropDate) - Date.now());

  if (!p) {
    if (el.dataset.liveLabel) {
      el.innerHTML = `<p class="clock__live">${el.dataset.liveLabel}</p>`;
    } else {
      el.hidden = true;
    }
    return false;
  }

  if (el.dataset.format === 'compact') {
    el.textContent = compact(p);
    return true;
  }

  for (const unit of ['d', 'h', 'm', 's']) {
    const slot = el.querySelector(`[data-unit="${unit}"]`);
    if (slot) slot.textContent = p[unit];
  }
  return true;
}

// Ticks every [data-countdown] until its data-drop-date passes.
export function start(root = document) {
  for (const el of root.querySelectorAll('[data-countdown]')) {
    if (Number.isNaN(Date.parse(el.dataset.dropDate))) continue;
    if (!tick(el)) continue;
    const timer = setInterval(() => {
      if (!tick(el)) clearInterval(timer);
    }, 1000);
  }
}

if (typeof document !== 'undefined') start();
